import { allRoles, isAuthorized, lazyLoadView } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const sharedComponentsRoutes: RouteConfig[] = [
  {
    path: 'ui-user-select',
    name: 'ui-user-select',
    component: () => lazyLoadView(import('@/ui-kit/views/shared-components/UiKitUserSelectView.vue')),
    meta: {
      title: 'UserSelect',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-user-select',
    },
  },
]
